export const LANDING_SOCIAL_X = 'https://x.com/cronpay_';

export const LANDING_NAV_LINKS = [
    { id: 'features', label: 'Features' },
    { id: 'use-cases', label: 'Use cases' },
    { id: 'how-it-works', label: 'How it works' },
    { id: 'jobs-portal', label: 'Jobs' },
    { id: 'try-testnet', label: 'Try it' },
];
